import { normalizeTrack } from './trackModel';

export const FILTER_PRESETS = {
  lowEnd: { label: 'Low End Layer', lowPassHz: 180, highPassHz: 30, lowPassResonance: 0, eq: { low: 2, mid: 0, high: 0 } },
  underwater: { label: 'Underwater', lowPassHz: 1100, highPassHz: 0, lowPassResonance: 0.15, eq: { low: 0, mid: 0, high: 0 } },
  reset: { label: 'Reset EQ', lowPassHz: 0, highPassHz: 0, lowPassResonance: 0, eq: { low: 0, mid: 0, high: 0 } },
};

export function applyFilterPreset(effects, preset) {
  const { label, ...settings } = FILTER_PRESETS[preset] || FILTER_PRESETS.reset;
  return normalizeTrack({ effects: { ...effects, ...settings } }).effects;
}

// More slider travel for the bass range. The open end is a true bypass.
export const lowPassToPosition = hz => hz > 0 ? Math.max(0, Math.min(100, Math.log10(hz / 20) / 3 * 100)) : 100;
export const positionToLowPass = position => position >= 100 ? 0 : Math.round(20 * Math.pow(1000, position / 100));
export const formatCutoff = hz => hz > 0 ? hz >= 1000 ? `${(hz / 1000).toFixed(1)} kHz` : `${Math.round(hz)} Hz` : 'Off';
